import styled, { DefaultTheme } from "styled-components";

interface ChipContainerProps {
    $variant: 'success' | 'warning' | 'info' | 'default';
    $isDarkMode: boolean;
}

const getBackgroundColor = (variant: ChipContainerProps['$variant'], isDarkMode: boolean, theme: DefaultTheme) => {
    switch (variant) {
        case 'success':
            return theme.colors.theme.success;
        case 'warning':
            return theme.colors.theme.warning;
        case 'info':
            return theme.colors.theme.info;
        default:
            return theme.colors.theme.contentBgOpaque;
    }
};


export const ChipContainer = styled.div<ChipContainerProps>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 12px;
    background: ${({ $variant, $isDarkMode, theme }) => getBackgroundColor($variant, $isDarkMode, theme)};
    border-radius: 100px;
`;

export const ChipIconImage = styled.img<{ $isDarkMode: boolean }>`
    width: 16px;
    height: 16px;
    filter: ${({ $isDarkMode }) => $isDarkMode ? 'brightness(0) invert(1)' : 'brightness(0) invert(0)'};
`;

export const ChipText = styled.span<{ $isDarkMode: boolean, $fontSize?: string }>`
    color: ${({ theme }) => theme.colors.text.headings};
    font-size: ${({ $fontSize }) => $fontSize || '14px'};
    font-weight: 500;
`;